function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.7H3.75a1.502 1.502 0 00-1.5 1.5v14.25a.75.75 0 001.085.67L6 18.79l2.665 1.332a.75.75 0 00.67 0L12 18.789l2.665 1.332a.75.75 0 00.67 0L18 18.789l2.665 1.332a.749.749 0 001.085-.671V5.2a1.502 1.502 0 00-1.5-1.5zm-3.375 9.75h-9.75a.75.75 0 110-1.5h9.75a.75.75 0 110 1.5zm0-3h-9.75a.75.75 0 110-1.5h9.75a.75.75 0 110 1.5z",
    fill: props.fill
  }));
}

export default SvgReceipt;